// extracted by mini-css-extract-plugin
export default {"headingH2":"safety_headingH2__DAbIe","breadcrumbs":"safety_breadcrumbs__F0eeP","aboutp":"safety_aboutp__-hFv+","aboutH3":"safety_aboutH3__SXCD1"};